/** The `code` a public booking route puts on an error body. */
export const BOOKING_ERROR_CODES = {
  tooManyRequests: 'too_many_requests',
  bookingFormOutdated: 'booking_form_outdated',
} as const;

export type BookingErrorCode =
  (typeof BOOKING_ERROR_CODES)[keyof typeof BOOKING_ERROR_CODES];

export const TOO_MANY_ATTEMPTS_MESSAGE =
  'Too many attempts. Please try again later.';

export const BOOKING_FORM_OUTDATED_MESSAGE =
  'This booking form has changed. Please reload the page.';
